import React, { useRef } from "react";

const OTPInput = ({ value = "", onChange }) => {

  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const newValue = e.target.value;
    
    // Update the OTP value based on the input
    const otpArray = value.split("");
    otpArray[index] = newValue; // Update the specific index
    onChange(otpArray.join("")); // Call onChange with updated value

    if (newValue.length === 1) {
      if (index < inputs.current.length - 1) {
        inputs.current[index + 1].focus();
      }
    } else if (newValue.length === 0 && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && e.target.value === "") {
      inputs.current[index - 1].focus();
    }
  };

  return (
    <div className="mobileinputdiv-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <input
          key={index}
          id={`otp-${index + 1}`}
          className="mobileinput-2"
          type="number"
          maxLength="1"
          value={value[index] || ""} // Set the value for each input
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputs.current[index] = el)}
          required
        />
      ))}
    </div>
  );
};

export default OTPInput;
